// extracted by mini-css-extract-plugin
export default {"frameWrapper":"Z8nP6g7z","_shorts":"iMu2ux9A","frame":"G_0XvQYo"};